import { Component, OnInit, signal, WritableSignal, ChangeDetectionStrategy, inject } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { SessionService } from '../../services/session.service';
import { PermissionGroup, PermissionGroupService } from '@eadsysteme/ewsauthclient-v1';
import { PermissionGroupComponent } from '../permissions/permission-stages/permission-group/permission-group.component';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { Icons } from '../../util/Icons';
import { MatTooltip } from '@angular/material/tooltip';

import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { BreadCrumbService } from '../../../@vex/components/breadcrumbs/BreadCrumbService';
import { fadeInUp400ms } from '../../../@vex/animations/fade-in-up.animation';
import { stagger40ms } from '../../../@vex/animations/stagger.animation';
import { PageLayoutComponent } from '../../../@vex/components/page-layout/page-layout.component';
import { PageLayoutHeaderDirective } from '../../../@vex/components/page-layout/page-layout-header.directive';
import { PageLayoutContentDirective } from '../../../@vex/components/page-layout/page-layout-content.directive';
import { BreadcrumbsComponent } from '../../../@vex/components/breadcrumbs/breadcrumbs.component';

@Component({
	selector: 'ara-user-management',
	imports: [
		TranslocoDirective,
		PermissionGroupComponent,
		MatDivider,
		MatIcon,
		MatTooltip,
		PageLayoutComponent,
		PageLayoutHeaderDirective,
		PageLayoutContentDirective,
		BreadcrumbsComponent,
		MatProgressSpinner,
	],
	templateUrl: './user-management.component.html',
	styleUrl: './user-management.component.scss',
	changeDetection: ChangeDetectionStrategy.Eager,
	animations: [fadeInUp400ms, stagger40ms],
})
export class UserManagementComponent implements OnInit {
	sessionService = inject(SessionService);
	icons = inject(Icons);
	permissionGroupService = inject(PermissionGroupService);
	breadCrumbService = inject(BreadCrumbService);

	permissionGroups: WritableSignal<PermissionGroup[]> = signal([]);
	isLoading = signal(true);

	ngOnInit() {
		this.setBreadcrumbs();
		this.loadData();
	}

	loadData() {
		if (this.sessionService.permissionGroups) {
			this.permissionGroupService.getAllPermissionGroupsByRequester().subscribe((groups) => {
				this.permissionGroups.set(groups);
				this.isLoading.set(false);
			});
		} else {
			this.isLoading.set(false);
		}
	}

	private setBreadcrumbs() {
		this.breadCrumbService.reset();
		this.breadCrumbService.addBreadCrumb({
			translationKey: 'sideboard.benutzerverwaltung',
			icon: this.icons.get('manageAccounts'),
		});
	}
}
